var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcGoogleplayWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 50,
    viewBox: "0 0 46 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_1781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.47 12.4C11.1405 12.7896 10.9724 13.2905 11 13.8V35.92C10.966 36.4304 11.1349 36.9336 11.47 37.32L11.54 37.4L23.93 25.01V24.71L11.54 12.33L11.47 12.4Z",
    fill: "url(#paint0_linear_56_1781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0301 29.14L23.9301 25.01V24.71L28.0301 20.58L28.1201 20.64L33.0301 23.42C34.4301 24.21 34.4301 25.51 33.0301 26.31L28.1401 29.09L28.0301 29.14Z",
    fill: "url(#paint1_linear_56_1781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.15 29.08L23.93 24.86L11.47 37.32C11.7525 37.5715 12.1142 37.7162 12.4923 37.729C12.8704 37.7418 13.241 37.6218 13.54 37.39L28.15 29.08Z",
    fill: "url(#paint2_linear_56_1781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.15 20.64L13.54 12.34C13.243 12.1049 12.8726 11.9821 12.494 11.993C12.1154 12.004 11.7528 12.1481 11.47 12.4L23.93 24.86L28.15 20.64Z",
    fill: "url(#paint3_linear_56_1781)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.03 28.99L13.54 37.24C13.2519 37.4574 12.9009 37.575 12.54 37.575C12.1791 37.575 11.828 37.4574 11.54 37.24L11.47 37.31L11.54 37.39C11.828 37.6074 12.1791 37.725 12.54 37.725C12.9009 37.725 13.2519 37.6074 13.54 37.39L28.15 29.08L28.03 28.99Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M11.47 37.18C11.1488 36.7834 10.9914 36.2789 11.03 35.77V35.92C10.996 36.4304 11.1649 36.9336 11.5 37.32L11.57 37.25L11.47 37.18Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M33.03 26.16L28.03 28.99L28.12 29.08L33.03 26.3C33.3199 26.1774 33.5713 25.979 33.7578 25.7256C33.9444 25.4722 34.0591 25.1731 34.09 24.86C34.0275 25.1446 33.899 25.4105 33.7149 25.6363C33.5308 25.8621 33.2962 26.0415 33.03 26.16Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M13.54 12.48L33.03 23.56C33.2962 23.6786 33.5307 23.8579 33.7149 24.0838C33.899 24.3096 34.0275 24.5755 34.09 24.86C34.0591 24.5469 33.9443 24.2478 33.7578 23.9944C33.5713 23.741 33.3198 23.5426 33.03 23.42L13.54 12.34C12.15 11.54 11 12.2 11 13.8V13.95C11.03 12.35 12.15 11.69 13.54 12.48Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_56_1781",
    x1: 22.83,
    y1: 13.57,
    x2: 6.05003,
    y2: 30.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_56_1781",
    x1: 34.8601,
    y1: 24.86,
    x2: 10.6701,
    y2: 24.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_56_1781",
    x1: 25.86,
    y1: 27.16,
    x2: 3.09997,
    y2: 49.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_56_1781",
    x1: 8.32997,
    y1: 5.04002,
    x2: 18.49,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_1781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.09,
    height: 25.72,
    fill: "white",
    transform: "translate(11 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoogleplayWeb);
export default __webpack_public_path__ + "static/media/ic_googleplay_web.ffe7a750089619b0e2b446814325bc69.svg";
export { ForwardRef as ReactComponent };